// hooks/useCidades.ts
import { useState, useEffect } from "react";
import { Cidade } from "../../../interfaces/Cidade";
import { cidadeByIdService } from "../../../services/cidadeByIdService";

export const useCidadeEmpreend = (
  fetch: boolean,
  cidadeId: number | undefined
) => {
  const [isLoading, setIsLoading] = useState(true);
  const [cidade, setCidade] = useState<Cidade | null>(null);

  useEffect(() => {
    const fetchCidade = async () => {
      if (fetch && cidadeId) {
        setIsLoading(true);
        try {
          const data = await cidadeByIdService(cidadeId);
          if (data) {
            setCidade(data);
          } else {
            console.error("Dados não encontrados para o usuário");
          }
        } catch (error) {
          console.error("Erro ao buscar cidades:", error);
        } finally {
          setIsLoading(false);
        }
      } else {
        setIsLoading(false);
      }
    };

    fetchCidade();
  }, [cidadeId, fetch]); // Dependência de estadoId e fetch para garantir que a chamada seja feita quando necessário

  return { cidade, isLoading };
};
